import * as React from "react"

import { cn } from "@/lib/utils"
import styles from './card.module.css'

const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn(styles.card, className)} {...props} />
))
Card.displayName = "Card"

const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn(styles.header, className)} {...props} />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  // <h2> so the typical page flow is h1 (page hero) → h2 (card titles) →
  // h3 (body subheadings), without skipping levels. Callers supply the
  // visual size via className (e.g. `title-sm`) — the tag is semantic only.
  <h2 ref={ref} className={cn(styles.title, className)} {...props} />
))
CardTitle.displayName = "CardTitle"

const CardHeaderDescription = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('body-md', styles.description, className)} {...props} />
))
CardHeaderDescription.displayName = "CardHeaderDescription"

const CardBody = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('body-md', styles.body, className)} {...props} />
))
CardBody.displayName = "CardBody"

const CardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn(styles.footer, className)} {...props} />
))
CardFooter.displayName = "CardFooter"

const CardFooterDescription = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('body-md', styles.footerDescription, className)} {...props} />
))
CardFooterDescription.displayName = 'CardFooterDescription'

export const CardBodyDescription: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => (
  <div className={cn('body-md', styles.bodyDescription, className)} {...props} />
)

// Core exports plus aliases that match the older shadcn-style API
export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardHeaderDescription,
  CardBody,
  CardFooterDescription,
  CardBody as CardContent,
  CardBodyDescription as CardDescription,
}
